<div class="app-container">
    @if (authService.isAuthenticated()) {
        <header class="glass-panel main-header">
            <div class="logo">
                <span class="text-gradient">WorkGraph</span>
            </div>
            <nav></nav>
            <div class="user-profile">
                <div class="avatar" (click)="onLogout()" style="cursor: pointer" title="Logout">
                    {{ userInitial() }}
                </div>
            </div>
        </header>
    }

    <main class="main-content" [class.full-width]="isProjectsRoute()">
        <router-outlet></router-outlet>
    </main>
</div>
